const CreateID = () => {
    return (
        <>
            <div className="managementID-wrapper">
                <p>Create a new employee account so they can log in and participate in training.</p>

                <div className="managementID-inner">
                    <label>
                        Create Employee’s ID
                        <input placeholder="Enter Employee's ID">
                        </input>
                        <p>Use a 4-digit numeric ID (no letters, e.g: 1234)</p>
                    </label>
                    <label>
                        Employee's full name
                        <input placeholder="Enter Employee's full name">
                        </input>
                        <p>Enter full legal name</p>
                    </label>
                    <div className="flex-button">
                        <button className="cancel">
                            cancel
                        </button>
                        <button>
                            save
                        </button>
                    </div>
                </div>

            </div>
        </>
    )
}

export default CreateID;